import React from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row } from "react-bootstrap";

const Default = () => (
  <React.Fragment>
    <Helmet title="Dashboard" />
    <Container fluid className="p-0">
      <Row className="mb-2 mb-xl-3">
        <Col xs="auto" className="d-none d-sm-block">
          <h3>Dashboard</h3>
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

export default Default;
